import { render, staticRenderFns } from "./PackageRated.vue?vue&type=template&id=576219d9"
import script from "./PackageRated.vue?vue&type=script&lang=js"
export * from "./PackageRated.vue?vue&type=script&lang=js"
import style0 from "./PackageRated.vue?vue&type=style&index=0&id=576219d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./services.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fbackend.limatours.com.pe%2Fresources%2Fjs%2Fpages%2FClients%2FManageClient%2FPackage%2FPackageRated%2FPackageRated.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports